import React, { useEffect  } from 'react';
import { Route, Switch, useHistory } from 'react-router-dom';
import AppContext from './Context/AppContext';
import useGlobalState from './hooks/useGlobalState';
import AppRoute from './Routes/AppRoute';
import routes from './Routes/routes';
import LoginPage from './Components/Auth/LoginPage';
import LoadingSection from './Components/LoadingSection/LoadingSection';
import NotificationsContainer from './Components/Common/Notifications/NotificationsContainer';
import ModalGenericError from './Components/Common/ModalGenericError/ModalGenericError';
import GlobalUserMenu from './Components/Common/GlobalUserMenu/GlobalUserMenu';

import './App.css';
import './styles/generalVariables.css';
import './styles/stylesDesktop.css';
import './styles/stylesMobile.css';
import { applyPortalV2Background } from './util/portalV2Background';
import { isNativeApp } from './util/capacitorNative';
import { nativeColdStartPath } from './util/appDeepLink';

const App = () => {
    const globalState = useGlobalState();
    const history = useHistory();

    useEffect(() => {
        window.__oolaNavigate = (path) => {
            if (path) history.push(path);
        };
        if (window.__oolaPendingPath) {
            const pending = window.__oolaPendingPath;
            window.__oolaPendingPath = null;
            history.replace(pending);
        } else if (isNativeApp()) {
            const cold = nativeColdStartPath(history.location.pathname);
            if (cold) history.replace(cold);
        }
        return () => {
            delete window.__oolaNavigate;
        };
    }, [history]);

    useEffect(() => {
        applyPortalV2Background();

        document.documentElement.style.setProperty(
            '--vh',
            `${window.innerHeight / 100}px`
        );
        if (window.location.origin == 'https://oolalife.com') {
            window.location.replace(
                'https://www.oolalife.com' + window.location.pathname
            );
        }
    }, []);
    return (
        <div className="App">
            <AppContext.Provider value={globalState}>
                <NotificationsContainer />
                <GlobalUserMenu />
                <Switch>
                    <Route exact path="/" component={LoginPage} />
                    <Route exact path="/globalconfig.js" />

                    {routes.map((route, index) => (
                        <AppRoute
                            key={route.path}
                            path={route.path}
                            component={route.component}
                            isPrivate={route.isPrivate}
                            exact={route.isExact}
                            index={index}
                        />
                    ))}
                </Switch>
                <LoadingSection />
                <ModalGenericError/>
            </AppContext.Provider>
        </div>
    );
};

export default App;
